import { useUpsellModalTriggers } from '../../model/upsell/useUpsellModalTriggers';
import { UpsellModal } from './UpsellModal';

export const UpsellModalHost = () => {
  useUpsellModalTriggers();

  return <UpsellModal />;
};
